<template>
  <div>
    <a-table
      :bordered="border"
      :scroll="isScroll"
      :data-source="tableData"
      :columns="columns"
      :row-key="record => record.id"
      v-bind="$attrs"
      :pagination="false"
      v-on="$listeners"
    >
      <slot />
    </a-table>
    <!-- 分页 -->
    <div v-if="isPagination" style="display:flex; justify-content: space-between; margin-top:10px;">
      <div>{{ $t('order.显示第') }}{{ beginPage }}{{ $t('order.到第') }}{{ endPage }}{{ $t('order.条记录，总共') }}{{ total }}{{ $t('order.条记录') }}</div>
      <div>
        <a-pagination
          v-if="updateTool"
          v-model="page"
          :total="total"
          @change="changePagination"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePager',
  components: {},
  props: {
    isPagination: { // 是否开启分页
      type: Boolean,
      default: true
    },
    isScroll: { // 设置横向或纵向滚动
      type: Object,
      default: () => {
        return { x: 1500 }
      }
    },
    tableData: {
      type: Array,
      default: () => {},
      required: true
    },
    columns: {
      type: Array,
      default: () => {}
    },
    border: {
      type: Boolean,
      default: false
    },
    pageNum: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      limit: 10,
      updateTool: true,
      page: 1
    }
  },
  computed: {
    beginPage() {
      if (this.pageNum === 1) {
        return this.pageNum
      } else {
        return this.limit * (this.pageNum - 1) + 1
      }
    },
    endPage() {
      if (this.pageNum === 1) {
        return this.limit
      } else {
        return this.limit * this.pageNum
      }
    }
  },
  watch: {
    pageNum: {
      handler(v) {
        this.page = v
      },
      immediate: true
    }
  },
  methods: {
    changePagination(page) {
      this.$emit('changePagination', page)
    }
  }
}
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/component/base/TablePager.vue